export const menuUrl = {
  base: "/",
  cekPesanan: "/pesanan",
  cekPesananDetail: "/pesanan/:id",
  cekPesananDetailUrl: (id: string) => `/pesanan/${id}`,
  detailBrand: "/:brandIdUrl",
  detailBrandUrl: (brandIdUrl: string) => `/${brandIdUrl}`,
  riwayatPesanan: "/riwayat-pesanan",
};
